// extracted by mini-css-extract-plugin
export default {"measuresContainer":"KPIMeasuresField_measuresContainer__t-kwN","header":"KPIMeasuresField_header__nz9DX","input":"KPIMeasuresField_input__pilcZ"};